import CalendarIcon from "@mui/icons-material/CalendarTodayRounded";
import ApprovalIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ApproversIcon from "@mui/icons-material/GroupOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineRounded";
import { Stack, Typography } from "@mui/material";
import UserWithAvatar from "@entrilia/shared/components/UserWithAvatar";
import SelectIcon from "@entrilia/shared/icons/SelectIcon";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { ChecklistTask } from "../../../api/types/objectTypes";
import ApprovalStatusTag from "../../approvals/ApprovalStatusTag";
import InlineAttribute from "../../common/InlineAttribute";
import UsersAvatarGroup from "../../common/UsersAvatarGroup";
import ChecklistTaskStatusTag from "./ChecklistTaskStatusTag";

interface Props {
  task: ChecklistTask;
}

const emptyValue = "—";
const labelWidth = "10rem";

const ObjectTaskDetailsInfoSection = ({ task }: Props) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1" sx={{ py: 1 }}>
        Task Details
      </Typography>
      <InlineAttribute
        Icon={SelectIcon}
        label="Status"
        labelWidth={labelWidth}
        value={<ChecklistTaskStatusTag status={task.status} />}
      />
      <InlineAttribute
        Icon={ApproversIcon}
        label="Approvers"
        labelWidth={labelWidth}
        value={task.approvers.length > 0 ? <UsersAvatarGroup users={task.approvers} /> : emptyValue}
      />
      <InlineAttribute
        Icon={PersonIcon}
        label="Prepared by"
        labelWidth={labelWidth}
        value={task.completedBy ? <UserWithAvatar userName={task.completedBy.name} /> : emptyValue}
      />
      <InlineAttribute
        Icon={CalendarIcon}
        label="Prepared at"
        labelWidth={labelWidth}
        value={task.completedAt ? convertISODateTime(task.completedAt) : emptyValue}
      />
      <InlineAttribute
        Icon={ApprovalIcon}
        label="Approval"
        labelWidth={labelWidth}
        value={task.approvalStatus ? <ApprovalStatusTag status={task.approvalStatus} /> : emptyValue}
      />
      <InlineAttribute
        Icon={PersonIcon}
        label="Reviewed by"
        labelWidth={labelWidth}
        value={task.approvedBy ? <UserWithAvatar userName={task.approvedBy.name} /> : emptyValue}
      />
      <InlineAttribute
        Icon={CalendarIcon}
        label="Reviewed at"
        labelWidth={labelWidth}
        value={task.approvedAt ? convertISODateTime(task.approvedAt) : emptyValue}
      />
    </Stack>
  );
};

export default ObjectTaskDetailsInfoSection;
